<template>
  <div class="epManage">
    <!-- top -->
    <div class="epManage-top">
      <div class="epManage-top-title">
        <span>企业管理</span>
        <!-- 提示帮助图标 -->
        <div class="attention">
          <div class="attention-model">
            <i></i>
            <ul>
              <li>
                <p>有效期坐席
                  <span>当天企业对应属于使用中状态的坐席数统计</span>
                </p>
              </li>
              <li>
                <p> 未生效坐席
                  <span>当天企业对应属于未生效状态的坐席数统计</span>
                </p>
              </li>
              <li>
                <p> 已到期坐席
                  <span>当天企业对应属于已到期状态的坐席数统计</span>
                </p>
              </li>

            </ul>
          </div>
        </div>
      </div>

    </div>
    <!-- bottom -->
    <div class="epManage-bottom">
      <!-- 搜索栏&表单 -->
      <div class="epManage-form-search">
        <el-form :inline="true" :model="epManageFormVals" class="demo-form-inline">

          <el-form-item label="注册时间">
            <el-date-picker 
             align="right" 
             @change="dateRangeChange"
             v-model="epManageFormVals.datePickerModel" 
             type="daterange" 
             :placeholder="this.oldDateThirty +' - '+ this.newDate" 
             :picker-options="DatePickerOptionsEpManage">
            </el-date-picker>


          </el-form-item>

          <el-form-item label="注册账号">
            <el-input v-model="epManageFormVals.regAccount"></el-input>
          </el-form-item>
          <el-form-item label="企业名称">
            <el-select v-model="epManageFormVals.enterpriseName" filterable placeholder="全部">
              <el-option  label="全部" value="全部"></el-option>
              <el-option v-for="(item,index) in companyNamedatas" :key="index" :label="item" :value="item" :value-key="index"></el-option>
            </el-select>
          </el-form-item>

          <br>

          <el-form-item label="体验坐席数">
            <el-select v-model="epManageFormVals.experSeatNum" placeholder="全部">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="1个" value="1个"></el-option>
              <el-option label="不为1" value="不为1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="留言消息数">
            <el-select v-model="epManageFormVals.messageNum" placeholder="全部">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="0条" value="0条"></el-option>
              <el-option label="不为0" value="不为0"></el-option>
              <el-option label="无限制" value="无限制"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机器人消息数">
            <el-select v-model="epManageFormVals.robotMgeNum" placeholder="全部">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="0条" value="0条"></el-option>
              <el-option label="不为0" value="不为0"></el-option>
              <el-option label="无限制" value="无限制"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchCompanyData()">搜索</el-button>
            <a href="javascript:void(0)" @click="companyMangeDeriveData"></a>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据列表 -->
      <div class="epManage-list-manage">
        <table  show-overflow-tooltip="true">
          <thead>
            <tr>
              <th>注册时间</th>
              <th>注册账号</th>
              <th>企业名称</th>
              <th>体验坐席</th>
              <th>留言消息</th>
              <th>机器人消息</th>
              <th>有效期坐席</th>
              <th>未生效坐席</th>
              <th>已到期坐席</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in companyListDatas" :key="index">
              <td :title="item.registered_at">{{item.registered_at}}</td>
              <td :title="item.email">{{item.email}}</td>
              <td :title="item.company">{{item.company}}</td>
              <td>{{item.free_waiter_num}}</td>
              <td>{{item.leave_msg_num}}</td>
              <td>{{item.rb_msg_num}}</td>
              <td>{{item.charge_seats_ing}}</td>
              <td>{{item.charge_seats_prep}}</td>
              <td>{{item.charge_seats_expired}}</td>
              <td>
                <span @click="openManageModel(item,index)">管理</span>
              </td>
            </tr>
           
          </tbody>
        </table>
      </div>

      <!-- 分页器 -->
     <subpagination :paginationCurrentPage="currentPage" :totalToPag="companyTotal" @current-change="getCurrentListData"></subpagination>
    </div>
  </div>
</template>
<style lang='scss' scoped>

</style>


<script>
import "../../statics/css/enterpriseManage.scss";
import bus from "../../common/commonVue.js";
import qs from "qs";
// 导入分页子组件
import subpagination from "../subcomponent/subPaginationCom.vue";
export default {
  data() {
    return {
      // 表单初始数据
      epManageFormVals: {
        // 注册时间
        datePickerModel: '',
        // 注册账号
        regAccount: '',
        //企业名称
        enterpriseName: '',
        //体验坐席数
        experSeatNum:'',
        //留言消息数
        messageNum:'',
        //机器人消息数
        robotMgeNum:''
      },
      DatePickerOptionsEpManage: {
        shortcuts: [{
          text: '最近60天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      //当前日期和三十天前的日期
      newDate: "",
      oldDateThirty: "",
      //公司名称数据
      companyNamedatas:[],
      //公司列表数据
      companyListDatas:[
        {free_waiter_num:0}
      ],
      //公司总数
      companyTotal:0,
      // 设置属性
      free_waiter_num:0,

      startTime:"",
      endTime:"",
      currentPage:1
    }
  },
  created() {
    this.getThirtyDate();
    // 获取公司名
    this.getCompanyName();
    // 默认开启渲染列表

    this.searchCompanyData()
    
  },

  mounted() {
    //接收管理操作确定后的数据--渲染列表
    bus.$on("applycpmglistdata",  (data,index) => {
      //console.log(data);
      // console.log(this.companyListDatas[index]);
      this.companyListDatas[index].free_waiter_num = data.free_waiter_num;

      if(data.free_leave_msg_num == "infinite") {
            data.free_leave_msg_num = "无限制";
      }
      if(data.free_rb_msg_num == "infinite") {
            data.free_rb_msg_num = "无限制";
      }
      //判断有效期坐席数来添加消息数
      if(this.companyListDatas[index].charge_seats_ing == 0) {
        this.companyListDatas[index].leave_msg_num = data.free_leave_msg_num;
        this.companyListDatas[index].rb_msg_num = data.free_rb_msg_num;
      }
      
    })
  },
  methods: {
    // 开启管理操作弹出框
    openManageModel(companyListData,index) {
      bus.$emit("openManageOperationModel",companyListData,index);
    },
    //下拉框默认显示30天的时间
    getThirtyDate() {
      //当前时间
      const date = new Date();
      const day = date.getDate();
      const mon = date.getMonth() + 1;
      
      this.newDate = date.getFullYear() + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);

      //一个月前的时间
      const DateThirty = new Date(date.getTime() - 30 * 24 * 3600 * 1000);
      const DateThirtyMonth = DateThirty.getMonth() + 1;
      const DateThirtyDay = DateThirty.getDate();
      this.oldDateThirty = DateThirty.getFullYear() + "-" +
        (DateThirtyMonth < 10 ? "0" + DateThirtyMonth : DateThirtyMonth) + "-" +
        (DateThirtyDay < 10 ? "0" + DateThirtyDay : DateThirtyDay);
    },
    //获取公司名
    getCompanyName() {
      this.$ajax.post(
        "/api/company_names"
      ).then(res => {
        // console.log(res);
        this.companyNamedatas = res.data.data;
      })
    },

    //筛选企业数据
    searchCompanyData() {

      // console.log(register_start);
      // console.log(register_end);
      // console.log(this.epManageFormVals.regAccount);
      // console.log(this.epManageFormVals.enterpriseName);
      // console.log(this.epManageFormVals.experSeatNum);
      // console.log(this.epManageFormVals.messageNum);
      // console.log(this.epManageFormVals.robotMgeNum);


      const listParams = {
        page_length: 15,
        register_start: this.startTime || this.oldDateThirty,
        register_end: this.endTime || this.newDate,
        email: this.epManageFormVals.regAccount,
        company: this.epManageFormVals.enterpriseName,
        free_waiter_para:this.epManageFormVals.experSeatNum,
        leave_msg_para: this.epManageFormVals.messageNum,
        rb_msg_para: this.epManageFormVals.robotMgeNum
      } 
      //console.log("register", register_start || this.oldDateThirty)
      
      //体验坐席数筛选
      if(listParams.email == "") {
          delete listParams.email;
        }
        if(listParams.company == "全部" || listParams.company == "") {
          delete listParams.company;
        }
        if(listParams.free_waiter_para == "" || listParams.free_waiter_para == "全部") {
          delete listParams.free_waiter_para;
        }else if(listParams.free_waiter_para == "1个") {
          listParams.free_waiter_para = 1;
        }else if(listParams.free_waiter_para == "不为1") {
          listParams.free_waiter_para = 2;
      }
      //留言消息数筛选
      if(listParams.leave_msg_para == "" || listParams.leave_msg_para == "全部") {
          delete listParams.leave_msg_para;
        }else if(listParams.leave_msg_para == "0条") {
          listParams.leave_msg_para = 0;
        }else if(listParams.leave_msg_para == "不为0") {
          listParams.leave_msg_para = 1;
        }else if(listParams.leave_msg_para == "无限制") {
          listParams.leave_msg_para = 2;
      }
      //机器人消息数筛选
      if(listParams.rb_msg_para == "" || listParams.rb_msg_para == "全部") {
          delete listParams.rb_msg_para;
        }else if(listParams.rb_msg_para == "0条") {
          listParams.rb_msg_para = 0;
        }else if(listParams.rb_msg_para == "不为0") {
          listParams.rb_msg_para = 1;
        }else if(listParams.rb_msg_para == "无限制") {
          listParams.rb_msg_para = 2;
      }

      //console.log(listParams);
  
      this.getCompanyData(listParams);

      
       
    },
    //获取企业数据
    getCompanyData(parmas) {
      this.$ajax.post(
         "/api/get_companies",
         qs.stringify(parmas)
       ).then(res => {


           this.companyListDatas = res.data.data.companies;
           //获取数据总数
           this.companyTotal = res.data.data.total_num;
           for(var i = 0; i < this.companyListDatas.length; i++) {
            //  this.companyListDatas[i].charge_seats_ing = 1;
             if(this.companyListDatas[i].charge_seats_ing != 0) {
                this.companyListDatas[i].leave_msg_num = "无限制";
                this.companyListDatas[i].rb_msg_num = "无限制";
             }
             if(this.companyListDatas[i].leave_msg_num == "infinite") {
               this.companyListDatas[i].leave_msg_num = "无限制"
             }
             if(this.companyListDatas[i].rb_msg_num == "infinite") {
               this.companyListDatas[i].rb_msg_num = "无限制"
             }
           }
          // console.log("获取企业数据",this.companyListDatas);

          //点击搜索按钮，传值分页器，让分页器页数为1
          this.currentPage = 1;
       })
    },
    //根据分页器页数获取当前列表数据
    getCurrentListData(page) {
      this.currentPage = page;

      this.$ajax.post(
         "/api/company_page",
         qs.stringify({page:page})
       ).then(res => {
           //console.log(res);
           this.companyListDatas = res.data.data;
           for(var i = 0; i < this.companyListDatas.length; i++) {
            //  this.companyListDatas[i].charge_seats_ing = 1;
             if(this.companyListDatas[i].charge_seats_ing != 0) {
                this.companyListDatas[i].leave_msg_num = "无限制";
                this.companyListDatas[i].rb_msg_num = "无限制";
             }
             if(this.companyListDatas[i].leave_msg_num == "infinite") {
               this.companyListDatas[i].leave_msg_num = "无限制"
             }
             if(this.companyListDatas[i].rb_msg_num == "infinite") {
               this.companyListDatas[i].rb_msg_num = "无限制"
             }
           }
       })
    },
    //设置下拉框默认显示时间和显示相应的数据
    dateRangeChange(val) {
      if (val) {
        this.startTime = val.split(" ")[0];
        this.endTime = val.split(" ")[2];
      }
    },
    //导出数据
    companyMangeDeriveData() {
      
      this.$ajax.post(
        "/api/dump_companies"
      ).then(res => {
        this.$downloadFile(res.data.data);
      })
    }
  },
  // 注册子组件
  components: {
    subpagination
  }
}
</script>



// WEBPACK FOOTER //
// enterpriseManage.vue?5a729446